<div class="flex flex-col">
  <div class="py-2 uppercase">{{ name() }}</div>
  <div class="text-xs">
    {{ date() | dateFormat: MM_YYYY }}
  </div>

  @if (false) {
    <div class="flex items-center gap-1">
      <app-rate [rating]="rating()" />

      <div>({{ votes() }})</div>
    </div>
  }
</div>
